import { TailSpin } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { StyledMainBox } from "./StyledComponents/styled";
import { Backdrop, CircularProgress } from "@mui/material";

const ClearCacheLoader = () => {
    return (
        <StyledMainBox component="main">
            {/* ---------- loader code -------- */}
            <Backdrop sx={{ color: "#fff", zIndex: "9999" }} open={true}>
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    sx={(theme) => ({
                        color: "#fff",
                        animationDuration: "750ms",
                    })}
                />
            </Backdrop>
        </StyledMainBox>
    );
};

export default ClearCacheLoader;
